"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getRetailerPicture = void 0;

var _jsBase = require("js-base64");

var getRetailerPicture = function getRetailerPicture(retailerId, width, height) {
  return "https://d24s337exbt5zr.cloudfront.net/" + _jsBase.Base64.encode(JSON.stringify({
    bucket: process.env.REACT_APP_IMAGES_BUCKET,
    key: "retailers/".concat(retailerId, ".png"),
    edits: {
      resize: {
        width: width,
        height: height,
        fit: "fill",
        background: {
          r: 255,
          g: 255,
          b: 255,
          alpha: 0
        }
      }
    }
  }));
};

exports.getRetailerPicture = getRetailerPicture;